module.exports = __webpack_public_path__ + "img/slide3-m.211e02f4.png";